import React, { memo } from "react";

import { ShowcaseCard, ShowcaseNotice } from "ui/components/Showcase";
import CheckIcon from "ui/modules/fleet/vehicles/pages/VehicleDetailPage/components/VehicleDetailCard/components/VehicleEditCard/components/VehicleWizardIntro/scenes/CheckIcon";

import { countTires, formatTireDimension, TIRE_SET_INTRO_SAMPLE } from "../consts";
import { TireSetSceneProps } from "../types";

/** Korak "Dokumentacija": dokumenti seta, sažetak seta i sve uz set na jednom mjestu. */
const TireSetDocumentsScene: React.FC<TireSetSceneProps> = ({ formValues }) => {
  const firstTire = formValues.tires[0];
  const dimension = formatTireDimension(firstTire) || TIRE_SET_INTRO_SAMPLE.dimension;
  const quantity = countTires(formValues.tires) || TIRE_SET_INTRO_SAMPLE.quantity;

  return (
    <>
      <ShowcaseCard className="left-[0.5rem] top-[-1rem] w-[17rem] h-[18rem]" delay={0}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Dokumentacija seta</div>
          <div className="text-sm font-bold text-slate-800 truncate">{formValues.code || TIRE_SET_INTRO_SAMPLE.code}</div>
          <div className="mt-3 space-y-2">
            {TIRE_SET_INTRO_SAMPLE.documents.map((document) => (
              <div key={document} className="flex items-center gap-2 rounded-md bg-slate-50 px-2 py-2">
                <span className="flex items-center justify-center w-6 h-7 rounded-sm bg-rose-50 text-[0.5rem] font-bold text-rose-500 flex-shrink-0">
                  PDF
                </span>
                <span className="flex-1 text-[0.7rem] font-medium text-slate-700 truncate">{document}</span>
                <CheckIcon />
              </div>
            ))}
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="right-[-0.5rem] top-[6rem] w-[14rem]" delay={0.25}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Sažetak seta</div>
          <div className="mt-2 space-y-1.5 text-[0.7rem]">
            <div className="flex justify-between">
              <span className="text-slate-500">Dimenzija</span>
              <span className="font-semibold text-slate-700">{dimension}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-slate-500">Količina</span>
              <span className="font-semibold text-slate-700">{quantity} kom</span>
            </div>
            <div className="flex justify-between">
              <span className="text-slate-500">Skladište</span>
              <span className="font-semibold text-slate-700 truncate max-w-[7rem]">
                {formValues.warehouse?.name || TIRE_SET_INTRO_SAMPLE.warehouseName}
              </span>
            </div>
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="left-[-1.5rem] bottom-[-0.5rem] w-[15rem]" delay={0.5}>
        <ShowcaseNotice
          title="Sve uz set na jednom mjestu"
          subtitle="Gume, lokacija i dokumenti"
          iconClassName="bg-blue-100"
          icon={
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#1D4ED8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8zM14 2v6h6" />
            </svg>
          }
        />
      </ShowcaseCard>
    </>
  );
};

export default memo(TireSetDocumentsScene);
